import React, { useEffect, useState } from "react";
import Input from "../components/Input";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { handleApiError } from "../api/api";
import { toast } from "react-toastify";

const VerifyAccount = () => {
  const [code, setCode] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [resending, setResending] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [resendTime, setResendTime] = useState(0);
  // Get names from sessionStorage and remove any quotes if present
  const firstName = sessionStorage.getItem("firstName")?.replace(/['"]/g, '');
  const lastName = sessionStorage.getItem("lastName")?.replace(/['"]/g, '');

  const navigate = useNavigate();

  const token = sessionStorage.getItem("token");
  useEffect(() => {
    let timer: any;
    if (!resending && resendTime > 0) {
      timer = setTimeout(() => {
        setResendTime((prevTime) => prevTime - 1);
      }, 1000);
    } else {
      clearTimeout(timer);
    }
    return () => clearTimeout(timer);
  }, [resending, resendTime]);

const submitCode = () => {
  if (code === "") {
    toast("Please enter a code");
    return;
  }

  const newVerificationCode:string = sessionStorage.getItem("newVerificationCode") || "";

  if (newVerificationCode) {
    
    if (code.trim() !== newVerificationCode.trim()) {
      toast.error("The code entered does not match the latest verification code sent to your email.");
      setErrorMessage("Invalid code enteredttt");
      return;
    }
  }

  setSubmitting(true);

  const payload = {
    Email: sessionStorage.getItem("email"),
    Code: code,
  };

  const pageCount = 1;
  const apiUrl = `${process.env.REACT_APP_AUTH_API_URL}ValidateCode`;

  axios
    .post(apiUrl, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      if (res.data === 1) {
        sessionStorage.setItem("page", `${pageCount}`);
        sessionStorage.removeItem("newVerificationCode");
        navigate("/companion-registration");
      } else {
        toast.error("Invalid code entered tt");
        setErrorMessage("Invalid code enteredtt2");
      }
    })
    .catch((err) => {
      handleApiError(err);
      toast.error("Unable to verify code");
      setErrorMessage("Unable to verify code");
    })
    .finally(() => {
      setSubmitting(false);
    });
};


  const resendCodeMtd = () => {
    if (resending) return;
    setResending(true);
    setResendTime(60);
    const payload = {
      Email: sessionStorage.getItem("email"),
    };
    const apiUrl = `${process.env.REACT_APP_DEFAULT_URL}/api/services/new-verification-code`;
    axios
      .post(apiUrl, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.isSuccessful === true && res.data.statusCode === 200) {
            sessionStorage.setItem("newVerificationCode", res.data.verificationCode);
          toast("Code has been resent to your email");
        } else {
          toast.error(errorMessage);
          setErrorMessage("Unable to send code");
        }
      })
      .catch((err) => {
        handleApiError(err);
        toast.error(errorMessage);
        setErrorMessage("Unable to send code");
      })
      .finally(() => {
        setResending(false);
      });
  };

  return (
    <div className="flex items-center justify-center mt-[88px] h-[70vh]">
      <div className="bg-white text-black p-6 shadow-lg px-4">
        <div className="text-center">
          <h2 className="text-xl font-semibold mb-4">Verify Email</h2>
          <p className="text-lg mb-4 w-[400px] sm:w-[500px]">
            Hello {firstName} {lastName}, please enter the code you received
            below to activate your account
          </p>
          <div className="text-start">
            <Input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              label="Code"
              placeholder="code"
            />
          </div>
          <h2 className="text-red-500">{errorMessage}</h2>
          <div className="flex items-center justify-center gap-4 my-3">
            <button
              className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded"
              onClick={resendCodeMtd}
              disabled={resending || resendTime > 0}
            >
              {resending ? "Resending..." : "Resend"}
            </button>
            <button
              className="bg-[#038aae] hover:bg-green-600 text-white font-semibold py-2 px-4 rounded"
              onClick={submitCode}
              disabled={submitting}
            >
              {submitting ? "Submitting..." : "Proceed"}
            </button>
          </div>
          <div className="text-center mt-2">
            {resendTime > 0 && (
              <p>
                Resend in <strong>{resendTime}</strong> seconds
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyAccount;
